declare namespace $ {

	type $bog_theme_toggle__theme_auto_bog_dobro_app_1 = $mol_type_enforce<
		ReturnType< $bog_dobro_app['Theme'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $bog_theme_auto__theme_light_bog_dobro_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_light'] >
	>
	type $bog_theme_auto__theme_dark_bog_dobro_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_dark'] >
	>
	type $giper_bot__Space_bog_dobro_app_4 = $mol_type_enforce<
		any
		,
		ReturnType< $giper_bot['Space'] >
	>
	type $giper_bot__Sources_bog_dobro_app_5 = $mol_type_enforce<
		any
		,
		ReturnType< $giper_bot['Sources'] >
	>
	type $giper_bot__Donate_bog_dobro_app_6 = $mol_type_enforce<
		any
		,
		ReturnType< $giper_bot['Donate'] >
	>
	type $giper_bot__Support_bog_dobro_app_7 = $mol_type_enforce<
		any
		,
		ReturnType< $giper_bot['Support'] >
	>
	type $giper_bot__Lights_bog_dobro_app_8 = $mol_type_enforce<
		any
		,
		ReturnType< $giper_bot['Lights'] >
	>
	type $bog_ainews_app__menu_tools_bog_dobro_app_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_ainews_app['menu_tools'] >
	>
	type $bog_ainews_app__param_bog_dobro_app_10 = $mol_type_enforce<
		any
		,
		ReturnType< $bog_ainews_app['param'] >
	>
	type $bog_ainews_app__Theme_bog_dobro_app_11 = $mol_type_enforce<
		any
		,
		ReturnType< $bog_ainews_app['Theme'] >
	>
	type $mol_image__uri_bog_dobro_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['uri'] >
	>
	export class $bog_dobro_app extends $mol_book2_catalog {
		Theme_toggle( ): $bog_theme_toggle
		Theme( ): $bog_theme_auto
		Bot( ): $giper_bot
		Prof( ): $bog_dobro_app_prof
		Charity( ): $bog_dobro_app_charity
		Settings( ): $bog_dobro_app_settings
		Vaka( ): $bog_dobro_app_vaka
		Ainews( ): $bog_ainews_app
		Placeholder( ): any
		Menu_logo( ): $mol_image
		menu_title( ): string
		menu_tools( ): readonly(any)[]
		plugins( ): readonly(any)[]
		spreads( ): ({ 
			'	': ReturnType< $bog_dobro_app['Bot'] >,
			'prof': ReturnType< $bog_dobro_app['Prof'] >,
			'charity': ReturnType< $bog_dobro_app['Charity'] >,
			'settings': ReturnType< $bog_dobro_app['Settings'] >,
			'vaka': ReturnType< $bog_dobro_app['Vaka'] >,
			'ainews': ReturnType< $bog_dobro_app['Ainews'] >,
		}) 
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map